import {
  getEnv,
  getUA,
  converUrlParamsObj,
  isDevelopment,
  getLocationVars
} from '@/utils/utils'
import {
  ISharePageURLQueryParams,
  IBookSharePageURLQueryParams
} from '@kiss/typings/interfaces/bookShare'

// 接口域名
const apiUrlList = {
  dev: '',
  test: '',
  // 测试环境已经配置过反向代理，不用指定域名了
  prod: '',
  gray: ''
}

export const apiUrl: string = apiUrlList[isDevelopment ? 'dev' : getEnv()]

// 分享页数据上报的域名 上报给kiss业务数据库，可能将来会改成上报到3.5
// 目前改为3.5上报该接口上报全部屏蔽
// const dataReportUrlList = {
//   dev: 'http://projecty_back_api.stardustworld.cn',
//   test: 'http://projecty_back_api.stardustworld.cn',
//   prod: 'http://kiss-web.stardustgod.com',
//   gray: 'http://kiss-web.stardustgod.com'
// }

// export const dataReportApiUrl: string = dataReportUrlList[getEnv()]

export const downLoadUrlDic = {
  googlePlay:
    'https://play.google.com/store/apps/details?id=com.stardust.kissreader',
  appStore: 'https://apps.apple.com/app/kiss-read-write-romance/id1508942129'
}
// 'https://apps.apple.com/app/radish-fiction/id1076491465?ls=1'

const isIOS = getUA().ios
console.log(!!isIOS, '22')

export const downLoadUrl = isIOS
  ? downLoadUrlDic.appStore
  : downLoadUrlDic.googlePlay

// project {string} 如果是”scream”说明是T项目，如果是”kiss”或不传是跳到kiss
const { project } = getLocationVars()

const schemeString = project === 'scream' ? 'cmsscream' : 'cmskiss'
const deeplinkTypeKey = project === 'scream' ? 'nqns' : '5yxe'

export const getAdjustDeeplink = ({
  customParams,
  type = 1001,
  pushType = 1, // 分享H5页面的pushType ==1 默认跳到阅读页
  randomId,
  isForTest,
  contentType
}: ISharePageURLQueryParams): string => {
  // 为iOS同事开发调试deeplink保留的参数
  // const { lichen } = getLocationVars()
  // if (lichen) return lichen

  // ========
  // 直接用url里的adj_t 调试用
  //  contentType = 1|2|3   1=>小说 | 2=>听书 | 3=>漫画

  const { isAdj, adj_t, contentType: contentTypeParam = 1 } = getLocationVars()
  // 有传contentType就用传的，没传就看url上有没有
  // eslint-disable-next-line no-param-reassign
  contentType = contentType
    ? contentType
    : (Number(contentTypeParam) as 1 | 2 | 3)
  /** kiss的deepLink */
  // adj_t 用过的
  // cnsqb7p   old   2020.11.12 安卓正常 ios正常
  // 4ntid1e   new   2020.11.12 安卓不正常  ios未知
  // tgxvsp4 ios 2020.11.13
  // hj8nn1a andorid 2020.11.13
  const t_ios = 'tgxvsp4'
  const t_android = 'hj8nn1a'

  const adj_t_h5: string = isIOS ? t_ios : t_android

  const deepLink_kiss = encodeURIComponent(
    `cmskiss://?${converUrlParamsObj({
      ...customParams,
      type,
      pushType,
      randomId,
      adj_t: adj_t_h5
    })}`
  )

  // 广告投放 去掉isFromH5 换成新adj_t
  if (isAdj) {
    const adj_t_ios = 'pyxo2mp'
    const adj_t_android = 'd4yitmp'

    const adj_adj_t: string = isIOS ? adj_t_ios : adj_t_android

    // const adjDeepLink = encodeURIComponent(`${schemeString}://?type=${type}&parm1=${bookId}&pushType=${pushType}&randomId=${randomId}`)
    // return `https://${deeplinkTypeKey}.adj.st/${schemeString}?type=${type}&parm1=${parm1}&adj_t=${adj_adj_t}&adj_deep_link=${adjDeepLink}`

    const adjDeepLink = encodeURIComponent(
      `${schemeString}://?${converUrlParamsObj({
        type,
        ...customParams,
        pushType,
        randomId
      })}`
    )
    let link
    // scream 和 kiss 安卓使用就的上报规则 ios使用新上报规则
    if (project === 'scream') {
      link = `https://${deeplinkTypeKey}.adj.st/${schemeString}?${converUrlParamsObj(
        {
          type,
          ...customParams,
          adj_t: adj_adj_t,
          adj_deep_link: adjDeepLink
        }
      )}`
    } else {
      // KISS   新的ios和安卓的deeplink广告分享链接   与普通分享流程的区别在于追踪码adj_adj_t的不同，去掉is_from_h5字段
      // 除了第一个? 其他的参数带的问号?都需要被加密转义，为了好区分
      const af_web_dp = encodeURIComponent(
        `https://5yxe.adj.st/?adj_t=${adj_adj_t}`
      )
      const deep_link_value = encodeURIComponent(
        `cmskiss://?${converUrlParamsObj({
          type,
          ...customParams,
          pushType,
          contentType
        })}`
      )
      link = `https://kissapp.onelink.me/6Vxq?pid=test&c=CMS_APP_EXCHANGE&af_web_dp=${af_web_dp}&af_dp=${encodeURIComponent(
        'cmskiss://'
      )}&deep_link_value=${deep_link_value}`
    }
    return link
  }

  // ==============
  // 正常分享流程

  // isForTest === true 为了测试保留的功能 点击footer左侧kiss 模拟广告运营流程 => is_from_H!== 1

  // const deepLink = encodeURIComponent(`${schemeString}://?type=${type}&parm1=${bookId}&is_from_H5=${isForTest ? 2 : 1}&pushType=${pushType}&randomId=${randomId}`)
  // return `https://${deeplinkTypeKey}.adj.st/${schemeString}?type=${type}&parm1=${bookId}&adj_t=${adj_t_h5}&adj_deep_link=${deepLink}`

  const deepLink = encodeURIComponent(
    `${schemeString}://?${converUrlParamsObj({
      type,
      ...customParams,
      is_from_H5: isForTest ? 2 : 1,
      pushType,
      randomId
    })}`
  )
  let link
  // scream 使用旧的deeplink逻辑   kiss 安卓和ios使用新的逻辑 2021.9.1 H5第4期
  if (project === 'scream') {
    link = `https://${deeplinkTypeKey}.adj.st/${schemeString}?${converUrlParamsObj(
      {
        type,
        ...customParams,
        adj_t: adj_t_h5,
        adj_deep_link: deepLink
      }
    )}`
  } else {
    // KISS   新的ios和安卓的deeplink分享链接
    const af_web_dp = encodeURIComponent(
      `https://5yxe.adj.st/?adj_t=${adj_t_h5}`
    )
    const deep_link_value = encodeURIComponent(
      `cmskiss://?${converUrlParamsObj({
        type,
        ...customParams,
        is_from_H5: isForTest ? 2 : 1,
        pushType,
        contentType
      })}`
    )
    link = `https://kissapp.onelink.me/6Vxq?pid=test&c=CMS_APP_EXCHANGE&af_web_dp=${af_web_dp}&af_dp=${encodeURIComponent(
      'cmskiss://'
    )}&deep_link_value=${deep_link_value}`
    console.log('🚀 ~ file: url.ts ~ line 179 ~ link', link)
  }
  return link
}
// kiss自定义协议
export const appSchemeLink = `${schemeString}://kiss`

export const createBookSharePageUrl = ({
  bookId,
  type = 1001,
  pushType = 1,
  randomId
}: IBookSharePageURLQueryParams): string =>
  converUrlParamsObj({ bookId, type, pushType, randomId })
